import * as Sentry from '@sentry/react'
import { applyMiddleware, compose, createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { getAccessToken, getRefreshToken, isImpersonated } from '../api/auth/tokenStorage'
import { authenticateDestroy, authenticateInitial } from './auth'
import rootReducer from './reducers'
import rootSaga from './sagas'

const sagaMiddleware = createSagaMiddleware()
const middlewares = [sagaMiddleware]
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const appReducer = (state, action) => {
    if (action.type === authenticateDestroy.toString()) {
        state = undefined
    }

    return rootReducer(state, action)
}

// Restore redux auth state on page reload
const restoreAuthState = (targetStore) => {
    const accessToken = getAccessToken()
    const refreshToken = getRefreshToken()
    const isImpersonatedFlag = isImpersonated()

    // Skip rehydrating auth state when on the impersonation route
    const pathname = window.location.pathname.replace(/\/$/, '')
    if (accessToken && refreshToken && pathname !== '/impersonation') {
        targetStore.dispatch(authenticateInitial({ accessToken, refreshToken, isImpersonated: isImpersonatedFlag }))
    }
}

export let store

export function configureStore(initialState) {
    const sentryReduxEnhancer = Sentry.createReduxEnhancer()
    const enhancers = composeEnhancers(applyMiddleware(...middlewares), sentryReduxEnhancer)

    store = createStore(appReducer, initialState, enhancers)
    sagaMiddleware.run(rootSaga)
    restoreAuthState(store)
    return store
}

// added for testing purposes
export function setupStore(preloadedState = {}) {
    const sagaMiddleware = createSagaMiddleware()
    const middlewares = [sagaMiddleware]
    const testStore = createStore(appReducer, preloadedState, applyMiddleware(...middlewares))

    sagaMiddleware.run(rootSaga)
    restoreAuthState(testStore)
    return testStore
}
